import { useEffect, useRef, useState } from 'react'
import { JpgIconEmailPreview, PdfIconEmailPreview } from '../assets/images'
import SvgDropdownArrowGrey from '../assets/images/components/SvgDropdownArrowGrey'
import { DocumentDropDownProps, TAB_KEY_CONSTANTS } from '../utils'
import CustomButton from './CustomButton'

const DocumentDropDown: React.FC<DocumentDropDownProps> = ({
  attachment,
  options,
  onOptionClick,
  disabled,
  dataQaId,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  const toggleDropdown = () => {
    if (!disabled) {
      setIsOpen((prev) => !prev)
    }
  }

  const handleOptionClick = (option: string) => {
    onOptionClick(option, attachment) // Pass full object
    setIsOpen(false)
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <CustomButton
        data-qa-id={dataQaId}
        className={`flex items-center border rounded-sm p-1 border-border-200 h-[1.625rem] w-[9.75rem] bg-white shadow-sm 
          ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100'}`}
        disabled={disabled}
        type="button"
        onClick={toggleDropdown}
        color="others"
      >
        <div className="flex items-center gap-2 truncate w-full">
          {attachment.attachment_name?.slice(-4) === TAB_KEY_CONSTANTS._PDF && (
            <PdfIconEmailPreview width="1rem" height="1rem" />
          )}
          {attachment.attachment_name?.slice(-4) === TAB_KEY_CONSTANTS._JPG && (
            <JpgIconEmailPreview width="1rem" height="1rem" />
          )}
          <span className="text-xs font-primary truncate w-full">
            {attachment.attachment_name}
          </span>
          {!disabled && (
            <SvgDropdownArrowGrey
              className={`transform transition-transform duration-200 ${
                isOpen ? 'rotate-180' : ''
              }`}
            />
          )}
        </div>
      </CustomButton>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute right-0 mt-1 w-[9.188rem] bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 z-50">
          <div className="py-1">
            {options.map((option) => (
              <div
                key={option.value}
                className="w-full px-4 py-2 text-left text-xs font-medium text-gray-700 hover:bg-secondary-25"
                onClick={() => handleOptionClick(option.value)}
              >
                {option.label}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default DocumentDropDown
